import TextInput from '@/components/common/TextInput';
import { useTranslation } from 'react-i18next';
import { TrackEditViewTemplateProps } from '../TrackEditViewTemplate';
import { BaseFormGroupProps } from './types';

type Props = Pick<
  TrackEditViewTemplateProps,
  | 'handleInput'
  | 'baseMixedTrack'
  | 'trackData'
  | 'areNewMultipleTracks'
  | 'isMultipleTrack'
  | 'fieldHasErrors'
  | 'findErrorMessage'
> &
  BaseFormGroupProps;

export default function TrackVersionFormGroup({
  isMultipleTrack,
  trackData,
  baseMixedTrack,
  readonly,
  disabled,
  areNewMultipleTracks,
  handleInput,
  fieldHasErrors,
  findErrorMessage,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <TextInput
        labelClassName="col-sm-3 form-label"
        labelTitle={t('track.version')}
        handleInput={(e) => handleInput('version', e.target.value)}
        handleUndo={(value) => handleInput('version', value)}
        id="version"
        type="text"
        value={
          !isMultipleTrack
            ? trackData.version
            : (baseMixedTrack?.version?.value as string)
        }
        inputClassname="form-control"
        className="col-sm-6"
        hasErrors={!isMultipleTrack ? fieldHasErrors('Version') : false}
        errorMessage={!isMultipleTrack ? findErrorMessage('Version') : ''}
        isDisabled={disabled}
        isReadOnly={readonly}
        mixedValue={baseMixedTrack?.version}
        showChangeIndicator={!areNewMultipleTracks}
      />
    </div>
  );
}
